export const mockData = {
  header: {
    logo: "Rockwell Bookkeeping",
    clientLoginText: "Client Login (Coming Soon)",
    ctaText: "Book Pay-App Audit"
  },
  hero: {
    title: "Construction Bookkeeping That Keeps Cash Flowing",
    subtitle: "Job-costed books you can trust, plus AIA pay-app prep (G702/G703)—so your packets get accepted the first time and you get paid on time.",
    ctaPrimary: "Book a 20-Minute Fit Call",
    ctaSecondary: "Get My Estimate by Email",
    supportLine: "Works with QuickBooks Online, Knowify, Procore (owner-portal submissions supported)"
  },
  whyChoose: {
    title: "Why Contractors Choose Rockwell",
    items: [
      {
        title: "AIA-Ready Books",
        description: "Job-costed QuickBooks, mapped for progress billing (G702/G703)."
      },
      {
        title: "Clean Requisitions, Fewer Resubmits",
        description: "We check retainage, stored materials, change orders, math, signatures, and dates before you submit."
      },
      {
        title: "Works With Your Stack",
        description: "QBO • Knowify • Procore."
      },
      {
        title: "Fast Turnarounds",
        description: "Typical monthly requisition prep in 2–4 business days once docs are complete."
      },
      {
        title: "No Long-Term Lock-In",
        description: "Month-to-month after setup."
      }
    ]
  },
  howItWorks: {
    title: "How It Works",
    steps: [
      {
        title: "Get Your Books Job-Cost Ready",
        description: "We clean and standardize your QuickBooks Online, map jobs and cost codes, and sync with Knowify if you use it."
      },
      {
        title: "Monthly Close + Reports",
        description: "Accruals, reconciliations, WIP/job-cost reports you can actually use to run projects."
      },
      {
        title: "AIA Pay-App Support (Add-On)",
        description: "We prepare/check your G702/G703 requisition (retainage, SOV, COs, stored materials), and submit through your owner portal (e.g., Procore) or hand you a clean requisition to send."
      }
    ]
  },
  services: {
    title: "Services",
    items: [
      {
        title: "Construction Bookkeeping (Core)",
        description: "Job costing, monthly close, reconciliations, WIP, 1099s, vendor management, light AP."
      },
      {
        title: "Knowify + QBO Setup & Training",
        description: "Project mapping, job-cost structure, progress-billing workflows."
      },
      {
        title: "AIA Pay-App Prep (G702/G703) — Add-On",
        description: "Requisition assembly and QA (math/signatures/periods), retainage & stored materials, change-order rollups, portal submission & tracking."
      }
    ]
  },
  resubmits: {
    title: "Fewer Resubmits. Faster Approvals.",
    description: "We prevent the common rejection triggers: wrong retainage math, SOV totals off, missing CO log, stale certificates, unsigned forms, period mismatches, missing stored-materials backup.",
    ctaText: "Get the Pay-App Readiness Checklist"
  },
  about: {
    title: "Meet Craig — Architect Turned Construction Finance & Pay-App Specialist",
    quote: "I'm a licensed architect with 15+ years in construction administration—the part of the job where cash flow lives or dies. I've managed project budgets, prepared and reviewed AIA G702/G703 pay applications, handled payment processing, and overseen change orders, contract reviews, and cost estimates on active projects. I know exactly why requisitions get rejected—and how to prevent it. I align QuickBooks + Knowify with your Schedule of Values, then deliver clean, submission‑ready requisitions that cut resubmits and speed approvals so your team can stay focused on building.",
    credentials: "QuickBooks Online • Knowify • AIA Pay-App Specialist"
  },
  pricing: {
    title: "Pricing — Project-Based, Then Monthly",
    intro: "Most contractors start with a Fit Call → Foundational Cleanup → monthly service.",
    bookkeeping: {
      title: "Construction Bookkeeping (Monthly)",
      tiers: [
        { name: "Starter (1–3 active projects)", price: "from $650/mo" },
        { name: "Growth (4–8 projects)", price: "from $1,100/mo" },
        { name: "Pro (9–15 projects)", price: "from $1,900/mo" }
      ]
    },
    payApp: {
      title: "AIA Pay-App Prep (Add-On, per active project)",
      tiers: [
        { name: "Standard requisition (G702/G703)", price: "$300–$600 / month" },
        { name: "Portal-submitted or complex", price: "$600–$900 / month" }
      ]
    },
    footnote: "Final quote depends on active projects, monthly expense volume, and owner-portal requirements (e.g., Procore).",
    ctaPrimary: "Book a 20-Minute Fit Call",
    ctaSecondary: "Get My Estimate by Email"
  },
  leadMagnet: {
    title: "Free: Pay-App Readiness Checklist (PDF)",
    description: "A 10-point G702/G703 checklist that prevents avoidable resubmits.",
    buttonText: "Email Me the Checklist"
  },
  faq: {
    title: "Frequently Asked Questions",
    items: [
      {
        question: "How do you price?",
        answer: "Based on active projects, monthly expense volume, and whether we submit via owner portals. Starter plans begin from $650/mo plus any Pay-App add-ons."
      },
      {
        question: "What's included in Pay-App Prep?",
        answer: "G702/G703 assembly & QA, retainage and stored-materials math, change-order rollups, ready-to-submit requisition, or portal submission & tracking."
      },
      {
        question: "Do you support retainage-only or final billing?",
        answer: "Yes—retainage releases and final requisitions included when needed."
      },
      {
        question: "Do you work inside Procore?",
        answer: "Yes—submission and tracking supported."
      },
      {
        question: "Can you set up Knowify + QuickBooks for AIA billing?",
        answer: "Yes—this is our standard stack."
      },
      {
        question: "Do you handle non-AIA progress billing?",
        answer: "Yes—fixed price, T&M, and cost-plus workflows are supported."
      }
    ]
  },
  footer: {
    tagline: "Nationwide • Works with QuickBooks, Knowify, Procore • Not a CPA or legal advisor",
    email: "info@rockwellbookkeeping.com",
    phone: "(914) 237-2867",
    copyright: "© 2025 Rockwell Bookkeeping. All rights reserved."
  },
  modals: {
    clientLogin: {
      headline: "Client Portal (Coming Soon)",
      body: "Secure uploads by project, status tracking, and fewer resubmits—all in one place. Want early access?",
      buttonText: "Notify Me When It's Live",
      successMessage: "You're on the list. We'll email you when the portal opens."
    },
    estimateThankYou: {
      headline: "Thanks—Your Estimate Is On the Way",
      body: "Want a faster number? Book a 20-Minute Fit Call and tell us your project count.",
      buttonText: "Book a 20-Minute Fit Call"
    },
    checklistThankYou: {
      headline: "Checklist Sent!",
      body: "While you're here, grab a spot on the calendar and we'll walk your next pay app through the checklist together.",
      buttonText: "Book a 20-Minute Fit Call"
    }
  }
};